<script setup>
import { defineProps, defineEmits, ref, watch, toRef } from 'vue';
import InputText from 'primevue/inputtext';
import FloatLabel from 'primevue/floatlabel';

const props = defineProps({
    content: {
        type: String,
        required: true,
        default: ''
    },
    validation: {
        type: Array,
        default: () => []
    },
    element: {
        type: Object,
        required: true
    }
});

const emit = defineEmits(['update:content', 'changed', 'validated', 'unvalidated']);
const valueRef = ref('');
const valid = ref(true);
const invalidmessage = ref('');

const content = toRef(props, 'content');
watch(content, (newValue) => {
  valueRef.value = newValue;
});

const validateRules = () => {
  let isValid = true;
  let value = valueRef.value;

  for (const rule of props.validation) {
    // Replace 'value' in the test expression with the actual value
    // Fix common typo in test expressions and ensure proper string handling
    const testExpression = rule.test
      .replace(/lenght/g, 'length');
    try {
      const func = new Function('value', `return ${testExpression}`);
      if (!func(value)) {
        isValid = false;
        emit('unvalidated', rule.message);
        invalidmessage.value = rule.message;
        break;
      }
    } catch (error) {
      console.error('Error evaluating validation rule:', error);
      isValid = false;
      emit('unvalidated', 'Error validating field');
      break;
    }
  }
  if (isValid) {
    valid.value = true;
    emit('validated');
  }
};

// Watch for value changes to trigger validation
watch(valueRef, (newValue, oldValue) => {
  if(newValue !== oldValue) {
    valid.value = false;
    validateRules();
    if (valid.value) {
      emit('update:content', newValue);
      emit('changed');
      invalidmessage.value = '';
    }
  }  
});

// Initialize value with content prop
valueRef.value = props.content;

</script>

<template>
  <FloatLabel variant="on" class="pb-1 pt-1">
    <InputText class="w-full" type="text" size="small" v-model="valueRef" :invalid="!valid" />
    <label for="in_label" class="z-1" style="text-overflow: ellipsis; white-space: nowrap;">
      {{ element.name }}
    </label>
    <div class="z-1 text-xs text-red-800 font-bold">
      {{ !valid ? invalidmessage : '' }}
    </div>
  </FloatLabel>
</template>

<style scoped>

</style>